import DataSoap from "@/services/DataSoap";
import { DetailSoap, Soap } from "@/types";
// import UserLogin from "@/utility/User";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
// import { userInfo } from "os";
import { userModule } from "./user";
import { appModule } from "./app";

export interface SoapState {
  soapAll: DetailSoap[];
  soap: Soap[];
  detailSoap: DetailSoap[];
  status: number;
  ctt: CttSoap;
}

interface CttSoap {
  id: number;
  s: any;
  o: any;
  a: any;
  p: any;
  instruksi: string;
  created_at: string;
  examined_at: string | Date;
}

@Module({ store, dynamic: true, name: "storeSoap" })
class SoapStore extends VuexModule implements SoapState {
  soapAll: DetailSoap[] = [];
  detailSoap: DetailSoap[] = [];
  soap: Soap[] = [];
  soapAllPerawat = [];
  status = 0;
  ctt = {} as CttSoap;

  @Mutation SET_ALL_SOAP(soapAll: DetailSoap[]) {
    this.soapAll = soapAll;
  }
  @Mutation SET_ALL_SOAP_PERAWAT(soapAllPerawat: []) {
    this.soapAllPerawat = soapAllPerawat;
  }
  @Mutation SET_SOAP(soap: Soap[]) {
    this.soap = soap;
  }
  @Mutation SET_SOAP_OBJECT(detailSoap: DetailSoap[]) {
    this.detailSoap = detailSoap;
  }
  @Mutation SET_STATUS_SOAP(status: number) {
    this.status = status;
  }
  @Mutation SET_CTT(ctt: CttSoap) {
    this.ctt = ctt;
  }

  @Action act_soap_on_reg(reg) {
    const idUser = userModule.user.id;

    appModule.setLoading(true);
    if (userModule.user.profesi == "Dokter") {
      const dt = DataSoap.getDataSoapDokter(reg, idUser);
      dt.then(dt => {
        appModule.setLoading(false);
        const soap = dt;
        const status = dt.status;
        const detailsoap = dt.data;
        this.SET_SOAP(soap);
        this.SET_STATUS_SOAP(status);
        this.SET_SOAP_OBJECT(detailsoap);

        if (dt.data.length == 0) {
          const det: CttSoap = {
            id: null,
            s: null,
            o: null,
            a: null,
            p: null,
            instruksi: null,
            created_at: "",
            examined_at: null
          };
          this.SET_CTT(det);
        } else {
          this.SET_CTT(detailsoap[0]);
        }
      });
    } else {
      const dt = DataSoap.getDataSoapPerawat(reg, idUser);
      dt.then(dt => {
        appModule.setLoading(false);
        const soap = dt;
        const status = dt.status;
        const detailsoap = dt.data;
        this.SET_SOAP(soap);
        this.SET_STATUS_SOAP(status);
        this.SET_SOAP_OBJECT(detailsoap);
        if (dt.data.length == 0) {
          const det: CttSoap = {
            id: null,
            s: null,
            o: null,
            a: null,
            p: null,
            instruksi: null,
            created_at: "",
            examined_at: null
          };
          this.SET_CTT(det);
        } else {
          this.SET_CTT(detailsoap[0]);
        }
      });
    }
    const data = DataSoap.getDataAllSoapDokter(reg);
    data.then(data => {
      const soapAll = data.data;
      // console.log("all", soapAll);
      this.SET_ALL_SOAP(soapAll);
    });
    const per = DataSoap.getDataAllSoapPerawat(reg);
    per.then(per => {
      const soap = per.data;
      // console.log("allperawat", soap);
      this.SET_ALL_SOAP_PERAWAT(soap);
    });
  }

  @Action act_clear_ctt() {
    const det: CttSoap = {
      id: null,
      s: null,
      o: null,
      a: null,
      p: null,
      instruksi: null,
      created_at: "",
      examined_at: null
    };
    this.SET_CTT(det);
  }

  @Action act_on_soap_all(reg) {
    const dt = DataSoap.getDataAllSoap(reg);
    dt.then(dt => {
      const soapAll = dt.data;
      this.SET_ALL_SOAP(soapAll);
    });
  }

  @Action clear_soap_all() {
    const soapAll = [];
    this.SET_ALL_SOAP(soapAll);
  }

  // @Action act_on_soap_dokter_all(reg) {
  //     console.log('allreg', reg)
  //     const dt = DataSoap.getDataAllSoapDokter(reg);
  //     dt.then(dt => {
  //         const soapAll = dt.data
  //         console.log('all', soapAll)
  //         this.SET_ALL_SOAP(soapAll);
  //     });
  // }
  // soapByDokter(reg: string,idUser: number) {
  //     const dt = DataSoap.getDataSoapDokter(reg,idUser);
  //   dt.then(dt => {
  //         const soap = dt
  //         this.SET_SOAP(soap);
  //     });
  // }
  // soapByPerawat(reg: string,idUser: number) {
  //     const dt = DataSoap.getDataSoapPerawat(reg,idUser);
  //     dt.then(dt => {
  //             const soap = dt
  //             this.SET_SOAP(soap);
  //     });
  // }
}

export const storeSoap = getModule(SoapStore);
